export default "__VITE_ASSET__r60yxjbI__"